import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const painPoints = [<>
    Te va bien en tu vida, pero en la cama{' '}
    <strong className="text-white" data-id="element-165">no durás lo que te gustaría</strong> y eso te
    carcome por dentro
  </>, <>
    Tenés <strong className="text-brand-red" data-id="element-166">miedo</strong> de que tu mujer
    pierda el deseo, el respeto o las ganas de estar con vos por tu falta de
    control
  </>, <>
    Evitás recibir sexo oral o ciertas posiciones/ritmos por miedo a acabar
    enseguida y{' '}
    <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-167">
      perderte la experiencia
    </span>
  </>, <>
    No querés depender de pastillas, cremas retardantes ni trucos peligrosos que
    te <strong className="text-white" data-id="element-168">quitan sensación</strong>
  </>, <>
    Querés entrar a la cama con{' '}
    <strong className="text-brand-gold" data-id="element-169">confianza absoluta</strong> sabiendo que
    dominás completamente la situación
  </>];
export function PainPoints() {
  return <section className="py-16 px-4 bg-black relative border-t border-gray-900" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-172">
          <span className="text-6xl mb-6 block" data-id="element-173">💪</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-174">
            Este libro es para vos si...
          </h2>
        </motion.div>

        <div className="space-y-4 mb-10" data-id="element-175">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-brand-card p-6 rounded-xl border border-gray-800 hover:border-gray-700 transition-colors" data-id="element-176">
              <span className="text-2xl shrink-0" data-id="element-177">✅</span>
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-178">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-red/10 border border-brand-red/30 p-8 rounded-2xl text-center mb-10" data-id="element-179">
          
          <p className="text-xl text-brand-red font-semibold" data-id="element-180">
            Este protocolo va a cambiar tu vida sexual para siempre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-181">
          <Button data-id="element-182">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}